export default class LayoutNavigationHelper {
    static layoutHasContent(layout) {
        if (layout.getElementsByClassName('has-submenu').length > 0 && layout.querySelectorAll('.has-submenu .js-hide-navigation-arrow').length == 0) {
            return true;
        }

        var dropdown = layout.getElementsByClassName('navDropdown')[0];

        return !!dropdown && !!dropdown.childNodes && dropdown.childNodes.length > 0 && dropdown.querySelector('a');
    }

    static sublayoutHasContent(layout) {
        var dropdown = layout.getElementsByClassName('navLevelTwoDropdown')[0];

        return !!dropdown && !!dropdown.childNodes && dropdown.childNodes.length > 0;

    }

    static async getNavigationData(navigationElement) {
        if (!navigationElement) {
            return;
        }

        const sfPath = navigationElement.getAttribute('data-fetch-url');
        const endpoint = `/custom-api/navigation?path=${encodeURIComponent(sfPath)}`;

        const response = await fetch(endpoint);

        if (!response.ok) {
            throw new Error(`HTTP error ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    }
}